module.exports = __webpack_public_path__ + "img/high-five.3c31d4c2.svg";